import React, { useState, useEffect } from 'react'
import Layout from '../Layout'
import IDBSectionone from './IDBSectionone'
import { IdbSectiontwo } from './IDBSectiontwo'
import IDBIntro from './IDBIntro'
import Contact_us from '../Home/ContactUs'
import IDBContactUsToday from './IDBContactUsToday'
import IDBConnectWithUs from './IDBConnectWithUs'
import IDBSectionthree from './IDBSectionthree'
import { IDBSectionfour } from './IDBSectionfour'
import AllSectionone from '../ReusableComp/Sectionone';
import * as Images from '../../assets';
import ProgramBrochure from '../ReusableComp/ProgramBrochure'
import { fetchWithFormData } from '../../apiGeneralFunction'
import { trackCustomEvent } from '../../event_firebase';

const IDBPage = () => {
  const [data, setData] = useState([]);

  useEffect(() => {

    const formData = new FormData();

    fetchWithFormData(`idb_page`, formData)
      // .then(data => setData(data[0].data))
      .then(data => {
        if (data?.status === true) {
          setData(data?.data);
          trackCustomEvent('idb_page', { status: true });
        }
        else {
          // console.error('Status is not true:', data?.status);
          setData("null");
          trackCustomEvent('idb_page', { status: false });
        }
      })
      .catch(
      // error => console.error('Error fetching data:', error)
    );

  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      {/* <IDBSectionone/> */}
      <AllSectionone
        src={Images.idp_bg_new}
        // src={Images.make_my_business_bg}
        title={'Individual Development Program'}
        link_to2={'/our_services'}
        link_name2={'Our Services'}
        link_to3={'/idp'}
        link_name3={'Individual Development Program'}
      />
      <IDBIntro />
      <IdbSectiontwo data={data?.idplist} />
      {/* <IDBConnectWithUs /> */}
      <IDBSectionthree />
      {/* <IDBSectionfour data={data?.reviews} /> */}
      {/* <IDBContactUsToday /> */}
      {/* <Contact_us /> */}
    </Layout>
  )
}

export default IDBPage
